import getters from './getters';
import state from './state';

export default {
  namespaced: true,
  state,
  getters
};
